module.exports = __webpack_public_path__ + "static/media/21ECLAC2.44842b31.jpg";